// extracted by mini-css-extract-plugin
export default {"content":"Menu-module__content__kR8Ag","menu":"Menu-module__menu__qgATZ"};